import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-deepBlack border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Left Column - Company Info */}
          <div>
            <div className="flex flex-col leading-tight mb-6">
              <span className="text-white text-2xl font-bold tracking-wide">NEXTLIFE</span>
              <span className="text-gold text-sm tracking-widest">ASSET SALES</span>
            </div>
            <div className="space-y-3 text-lightGray text-sm">
              <p className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-gold mt-0.5"></i>
                <span>12215 Morning Ave, Downey, CA 90242</span>
              </p>
              <p>
                <a href="mailto:edgarg@nextlifeasset.com" className="text-gold hover:text-warmGold transition-colors cursor-pointer">
                  edgarg@nextlifeasset.com
                </a>
              </p>
              <p>
                <a href="tel:408-581-3979" className="text-gold hover:text-warmGold transition-colors cursor-pointer">
                  408-581-3979
                </a>
              </p>
            </div>
          </div>

          {/* Center Column - Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-lightGray hover:text-gold transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-lightGray hover:text-gold transition-colors text-sm cursor-pointer">
                  Returns
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-lightGray hover:text-gold transition-colors text-sm cursor-pointer">
                  Privacy
                </Link>
              </li>
            </ul>
          </div>

          {/* Right Column - Business Hours */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">Business Hours</h3>
            <div className="space-y-2 text-lightGray text-sm mb-6">
              <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
              <p>Saturday: 9:00 AM - 4:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
            <a
              href="mailto:edgarg@nextlifeasset.com"
              className="inline-block px-6 py-2.5 bg-gold text-black rounded-full hover:bg-warmGold transition-all duration-300 text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              Request Quote
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gold/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-white text-sm">
              © {new Date().getFullYear()} NEXTLIFE ASSET SALES LLC. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-warmGold transition-colors text-xl w-8 h-8 flex items-center justify-center cursor-pointer"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
              <a
                href="mailto:edgarg@nextlifeasset.com"
                className="text-gold hover:text-warmGold transition-colors text-xl w-8 h-8 flex items-center justify-center cursor-pointer"
              >
                <i className="ri-mail-line"></i>
              </a>
            </div>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold transition-colors text-sm cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
